import { LibraryIcon } from "./LibraryIcon";

export default LibraryIcon;
